export default "__VITE_ASSET__BsDhhlWz__"